import { useMemo } from 'react';
import { Case, CaseStatus } from '@/api/apis/case';
import { EtaType } from '@/types';
import { isAllowedStatus } from '@/utils/helpers';

export const useTxCenterEta = (caseData: Case) => {
  const {
    recipientHospitalDate,
    recipientHospitalTime,
    txEtaHospitalDate,
    txEtaHospitalTime,
    txEtaHospitalTimeZone,
    recipientHospitalTimeZone,
    recipientHospitalORChangeReason,
    status,
    txCenterDetails,
  } = caseData;

  const txEtaEnabled = isAllowedStatus({
    statusFrom: CaseStatus.PendingLogistics,
    statusTo: CaseStatus.Finished,
    currentStatus: status,
  });

  const displayEtaTypes: EtaType[] = useMemo(() => {
    return txEtaEnabled ? [EtaType.txCenterSta, EtaType.txCenterEta, EtaType.txCenterOr] : [EtaType.txCenterOr];
  }, [txEtaEnabled]);

  const txEtaData = useMemo(
    () => ({ txEtaHospitalDate, txEtaHospitalTime, txEtaHospitalTimeZone, txCenterDetails }),
    [txEtaHospitalDate, txEtaHospitalTime, txEtaHospitalTimeZone, txCenterDetails],
  );

  const txCenterOREta = useMemo(
    () => ({
      recipientHospitalDate,
      recipientHospitalTime,
      recipientHospitalTimeZone,
      recipientHospitalORChangeReason,
    }),
    [recipientHospitalDate, recipientHospitalTime, recipientHospitalTimeZone, recipientHospitalORChangeReason],
  );

  return {
    displayEtaTypes,
    txEtaData,
    txCenterOREta,
  };
};
